import {
  Button,
  Icon,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  RoundButton,
  roundButtonStylesMedium,
} from "@smartsuite/react-ui/lib";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useRootStore } from "../../../../stores/hooks";
import * as S from "./styled";

export enum DisplayState {
  CLOSED = "CLOSED",
  DISPLAYED = "DISPLAYED",
}

export const UsedAutomations: React.FC<{
  usedConnections: Array<{ link: string; automationId: string }>;
  onChangeState: (state: DisplayState) => void;
}> = ({ usedConnections, onChangeState }) => {
  const store = useRootStore();

  const [displayModal, setDisplayModal] = useState<boolean>(false);

  useEffect(() => {
    onChangeState(displayModal ? DisplayState.DISPLAYED : DisplayState.CLOSED);
  }, [displayModal]);

  if (usedConnections.length === 0) {
    return <></>;
  } else {
    return (
      <>
        <Button
          iconName="thin-open-in-new"
          iconSize="S"
          isContentReversed={true}
          onClick={() => setDisplayModal(true)}
          styles={S.buttonDetailsStyle}
        >
          {t("confirm-modal.used-automations")}
        </Button>
        {displayModal && (
          <>
            <ModalOverlay
              animation="fade"
              active={true}
              closeByEsc={false}
              onClose={() => {}}
              backdrop={false}
            >
              <S.Container>
                <Modal
                  styles={{ width: 600 }}
                  onClose={() => {}}
                  size="SM"
                  withoutHat={true}
                  header={
                    <>
                      <ModalHeader
                        title={t("confirm-modal.connections-used-in")}
                        titleSize="xs"
                      />
                      <S.Close>
                        <Icon
                          name="close"
                          color="currentColor"
                          onClick={() => {
                            setDisplayModal(false);
                          }}
                          transition
                        />
                      </S.Close>
                    </>
                  }
                  footer={
                    <ModalFooter
                      buttons={
                        <RoundButton
                          type="button"
                          styles={roundButtonStylesMedium}
                          onClick={() => {
                            setDisplayModal(false);
                          }}
                        >
                          {t("confirm-modal.close")}
                        </RoundButton>
                      }
                    ></ModalFooter>
                  }
                >
                  <S.ModalContent>
                    {usedConnections.map((connection) => (
                      <S.Link
                        key={connection.automationId}
                        href={`${store.config.smartsuiteBackendUrl.replace(
                          "/api/v1",
                          "",
                        )}/${store.config.accountId}/home/${
                          store.config.solutionId
                        }/automations/modal/${connection.automationId}`}
                        target="_blank"
                      >
                        {connection.link}
                      </S.Link>
                    ))}
                  </S.ModalContent>
                </Modal>
              </S.Container>
            </ModalOverlay>
          </>
        )}
      </>
    );
  }
};
